import { endOfDay, formatRFC3339 } from "date-fns";
import { useMemo } from "react";
import { usePagination, useSearch } from "@/hooks";
import { GetClientsParams } from "@/redux/apis/client/types";
import { useBookingDates } from "./useBookingDates";
import { useBookingFilters } from "./useBookingFilters";
import { useBookingSorting } from "./useBookingSorting";

export const useGetBookingsParams = () => {
  const { page, pageSize } = usePagination("bookings", 100);
  const { sorting, setSorting, sortKey, direction } = useBookingSorting();
  const { params: filterParams, filters, setFilters } = useBookingFilters();
  const [search, setSearch] = useSearch();
  // `persist` so this resolves the operator's remembered range on the very first render, exactly as
  // BookingControls does — otherwise the two disagree while the URL carries no date params.
  const [selectedDates, setSelectedDates] = useBookingDates({ persist: true });

  const params: GetClientsParams = useMemo(
    () => ({
      page,
      page_size: pageSize,
      sort: sortKey,
      direction,
      start_date_time: formatRFC3339(selectedDates.dateFrom),
      end_date_time: formatRFC3339(endOfDay(selectedDates.dateTo)),
      search,
      ...filterParams,
    }),
    [page, pageSize, sortKey, direction, selectedDates, search, filterParams]
  );

  return {
    params,
    sorting,
    setSorting,
    sortKey,
    direction,
    filters,
    setFilters,
    search,
    setSearch,
    selectedDates,
    setSelectedDates,
  };
};
